import React, { useState, useEffect } from 'react';
import { CheckboxGroup } from '@zydalabs/storefront-components';
import VariantOptionField from '../../../VariantOptionField';
import { VariantProperty, Option, CartItemOptions } from '../../../../../../service/types/generated';
import { usePersistedCountryDetails } from '../../../../../../common/hooks';

type MultipleOptionsType = {
  optionGroup: VariantProperty;
  addMultipleOptions: (options: Array<CartItemOptions>, existedOptionId: string) => void;
  setError: (error: boolean) => void;
  isArabic: boolean;
  selectedOptionsIds?: Array<string>;
};

const MultipleOptions: React.FC<MultipleOptionsType> = ({
  optionGroup,
  addMultipleOptions,
  setError,
  isArabic,
  selectedOptionsIds = [],
}) => {
  const [selectedOptions, setSelectedOptions] = useState<Array<string>>([]);
  const [persistedCountryDetails] = usePersistedCountryDetails();
  const { currency } = persistedCountryDetails || {};
  const { maxQuantity, minQuantity, uuid: existedOptionId } = optionGroup || {};

  useEffect(() => {
    if (selectedOptions.length < minQuantity) setError(true);
    else setError(false);
  }, [selectedOptions]);

  useEffect(() => {
    if (JSON.stringify(selectedOptionsIds) !== JSON.stringify(selectedOptions)) {
      setSelectedOptions(selectedOptionsIds);
    }
  }, [selectedOptionsIds]);

  const onSelectedOption = value => {
    addMultipleOptions(
      value.map(val => ({ optionId: val, optionGroupId: existedOptionId, optionQuantity: 1 })),
      existedOptionId,
    );
    if (value.length < minQuantity) setError(true);
    else setError(false);
    if (value.length <= maxQuantity) {
      setSelectedOptions(value);
    }
  };
  const isOptionDisabled = selectedOptionsIds.length >= optionGroup.maxQuantity && !!optionGroup.maxQuantity;
  return (
    <div data-testid="multiple-option-component">
      <CheckboxGroup
        fields={optionGroup.options.map((option: Option) => ({
          content: (
            <VariantOptionField
              fieldTitle={isArabic ? option.titleAr : option.titleEn}
              price={option.price}
              currency={currency}
            />
          ),
          fieldValue: option.uuid,
          disabled: isOptionDisabled && !selectedOptions.includes(option.uuid),
        }))}
        onChange={onSelectedOption}
        value={selectedOptions}
        mt={2}
        name={existedOptionId}
      />
    </div>
  );
};

export default MultipleOptions;
